import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { RouteLandingComponent } from './route-landing.component';
import { RouteLandingModule } from './route.landing.module';

export const routes: Routes = [
  {
    path: '',
    component: RouteLandingComponent,
  },
  {
    path: '*',
    redirectTo: '',
  },
];

@NgModule({
  imports: [
    RouteLandingModule,
    TranslateModule,
    RouterModule.forChild(routes),
  ],
})
export class RouteLandingRoutingModule {
}
